import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiEdit } from "react-icons/fi";
import Switch from "react-switch";
function CandidateStatusOrder() { 
    useEffect(() => {
        setTimeout(() => {
          document.getElementById("candidateStatusOrder").classList.add("active");
        }, 500);
      }, []);
      const [menuClick, setMenuClick] = useState(false)
      const toggleMenu = () => {
        setMenuClick(!menuClick)
      }
      const closeMenu = () => {
        setMenuClick(false)
      }
  return (
    <>
       <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"F"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
            <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="Candidate Status Order" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">
            <div className="xilliRight">
              <div className="xilliWrap">
                <div className="card main-card">
                  <div className="card-body">
                <div className="col-md-12">
                  <div className="xilliWrap table-wrap">
                    <div className="row">
                      <div className="col-md-4 m-auto">
                        <div className="barChartWrap pt-4">
                        <div className="form-group">
                          <label  className="col-sm-2 form-label">Name</label>
                          <div className="col-sm-12">
                            <input type="text" className="form-control" />
                          </div>
                        </div>
                        <div className="form-group">
                          <label  className="col-sm-2 form-label">Order</label>
                          <div className="col-sm-12">
                           <select className="form-control">
                            <option>1</option>
                           </select>
                          </div>
                        </div>
                        <span className="childIssueses">
                          <a className="btn-btn btn btn-btn2 btn-sm me-2">Save</a>
                          <a className="btn-btn btn btn-btn1 btn-sm">Cancel</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default CandidateStatusOrder;
